<template>
  <div>
    <TemplateRegistro @intro="login(nif, clave)">
      <label for="uname">
        <strong>Nº de documento de identidad</strong>
      </label>
      <input id="uname" v-model.trim="nif" type="text" placeholder="NIF, CIF o NIE" required @keydown="clearErrors()" />

      <label for="contrasena">
        <strong>Contraseña</strong>
      </label>
      <div class="campo">
        <input id="contrasena" type="password" v-model="clave" placeholder="Su contraseña" required
          @keydown="clearErrors()">
        <span>
          <fai :icon="['fas', 'eye']" @click.prevent="cambiarVisibilidad()" v-if="!mostrarPassword" />
          <fai :icon="['fas', 'eye-slash']" @click.prevent="cambiarVisibilidad()" v-if="mostrarPassword" />
        </span>
      </div>

      <div class="sep" />
      <PanelMensajes :mensaje="error" clase="error" />

      <button type="submit" class="pure-button ripple" @click.prevent="login(nif, clave)">
        <strong>Entrar</strong>
      </button>
      <div class="sep" />

      <a href="#" class="loginLink ripple" @click.prevent="registrarse">Soy usuario nuevo</a>
      <a href="#" class="loginLink ripple" @click.prevent="recordar">He olvidado mi contraseña</a>
    </TemplateRegistro>

    <AnadirAPaginaInicioIOS />
  </div>
</template>

<script>
export default {
  data() {
    return {
      nif: "",
      clave: "",
      error: "",
      mostrarPassword: false,
    };
  },

  computed: {

    passwordField() {
      return document.querySelector('#contrasena');
    },

    cliente() {
      return this.$store.state.portfolio.cliente;
    },

    userAgente() {
      return window.navigator.userAgent.toLowerCase();
    },

    platform() {
      return window.navigator.platform;
    },
  },

  methods: {
    login: async function (nif, password) {
      let result = await this.$store.dispatch("login", {
        usuario: nif ? nif.replace(/\s/g, '') : nif,
        password: password,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      await this.$store.dispatch("getPortfolio");
      await this.$store.dispatch("getUrlClubMMT");

      if (this.hayGdprPdte()) {
        this.$router.push({ name: "gdprTacito" });
      } else this.$router.replace({ name: "inicio" });
    },

    cambiarVisibilidad() {
      if (this.passwordField.getAttribute('type') == 'password') {
        this.passwordField.setAttribute('type', 'text')
        this.mostrarPassword = true;
      }
      else {
        this.passwordField.setAttribute('type', 'password');
        this.mostrarPassword = false;
      }
    },



    mostrarOcultarContraseña() {
      this.mostrarPassword = !this.mostrarPassword;

    },


    hayGdprPdte() {
      let cliente = this.$store.state.portfolio.cliente;
      let gdprEmpresas = cliente.gdprEmpresas;
      return gdprEmpresas == null;
    },

    registrarse() {
      this.$router.replace({
        name: "registroNif",
        params: { nif: this.nif },
      });
    },

    recordar() {
      this.$router.replace({
        name: "registroNifRecordar",
        params: { nif: this.nif },
      });
    },

    clearErrors() {
      /* eslint-disable */
      // console.log("Es ios" + isIos());
      console.log("Es standaloneMode:" + this.isInStandaloneMode);
      console.log("Mostrar pantalla de instalacion" + this.showInstallMessage);

      this.error = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.sep {
  height: 0.5rem;
}

.loginLink {
  margin-top: 0.6rem;
  color: $colorMMT;
  font-weight: bold;
}

.campo {
  position: relative;
  display: flex;
  align-items: center;
}


input {
  width: 100%;
}

.campo span {
  position: absolute;
  cursor: pointer;
  right: 0.8rem;

}
</style>
